"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _index = require("@/utils/index");
var _editwith = _interopRequireDefault(require("@/views/user/_editwith.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'userList',
  components: {
    editwith: _editwith.default,
    Pagination: _Pagination.default,
    selPlat: _selPlat.default,
    drawer: _filter.default
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    },
    siteInfo: function siteInfo() {
      return this.$store.getters.siteInfo;
    }
  },
  data: function data() {
    var _this = this;
    return {
      dealPhone: _index.dealPhone,
      form: {},
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      },
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        search_agent_id: '0',
        search_user_type: '2',
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      },
      memberDialog: false,
      memberObj: {
        status: 1,
        depend_type: 3,
        date_type: 0
      },
      tradeLogDialogVisible: false,
      tradeLogList: [],
      tradeLogLoading: false,
      tradeLogQuery: {
        user_id: '',
        start: 1,
        limit: 10,
        page_num: 1
      },
      orderDetailDialog: false,
      orderDetailLoading: false,
      orderDetail: {
        operate_flow: []
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/search/query_users';
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin / 1000, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end / 1000, '{y}-{m}-{d}');
      this.$get(url, listQuery).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this2.tableMaxH = window.innerHeight - _this2.$refs.order_table.$el.offsetTop - 80;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 拉黑 或 移除黑名单
     */
    setBlack: function setBlack(row) {
      var _this3 = this;
      //当前已是黑名单 -> 移除黑名单
      if (row.is_black_child == 1) {
        row.is_black_child = 0;
        this.doSetBlack(row, '');
        return;
      }
      //加入黑名单 -> 弹窗输入原因
      this.$prompt('请输入拉黑原因（选填）', '加入黑名单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPlaceholder: '请填写拉黑原因，便于后续追溯',
        inputValidator: function inputValidator() {
          return true;
        }
      }).then(function (_ref) {
        var value = _ref.value;
        row.is_black_child = 1;
        _this3.doSetBlack(row, value || '');
      }).catch(function () {});
    },
    doSetBlack: function doSetBlack(row, blackReason) {
      var _this4 = this;
      // 【操作埋点】2026-05-25 pc_user_black_1 加入/移除黑名单（第三参数自动上报）
      this.$post('agentapi/business/user_black_child_switch', {
        uid: row.id,
        is_black_child: row.is_black_child,
        black_reason: row.is_black_child == 1 ? blackReason : ''
      }, {
        operation_option: row.is_black_child == 1 ? '加入黑名单' : '移除黑名单',
        content: "".concat(row.is_black_child == 1 ? '加入' : '移除', "\u7528\u6237\u3010").concat(row.nick_name, "\u3011(ID:").concat(row.id, ") \u9ED1\u540D\u5355").concat(row.is_black_child == 1 && blackReason ? '，原因：' + blackReason : ''),
        operation_id: 'pc_user_black_1'
      }).then(function (res) {
        _this4.$message({
          message: '设置成功',
          type: 'success'
        });
        //同步更新列表里的black_reason字段
        if (row.is_black_child == 0) {
          row.black_reason = '';
        } else {
          row.black_reason = blackReason;
        }
      });
    },
    /**
     * 充值
     */
    recharge: function recharge(row) {
      var _this5 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var title = '余额充值';
      if (type == 1) {
        title = '余额充值';
      } else if (type == 2) {
        title = '储值卡赠值';
      } else {
        title = '储值卡充值';
      }
      this.$prompt('请输入充值金额', title, {
        confirmButtonText: '确定充值',
        cancelButtonText: '取消',
        inputPlaceholder: '正数为加，负数为减',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this5.loadObj = _this5.$loading({
              lock: true,
              text: '正在充值',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;
            _this5.$post('agentapi/business/invest_user_accout', {
              uid: row.id,
              type: type,
              money: value
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_user_recharge_1 用户充值
              _this5.$userReport.reportUserRecharge(row.id, row.nick_name, value, type);
              _this5.loadObj.close();
              _this5.$message({
                message: '充值成功',
                type: 'success'
              });
              _this5.toQuery();
              done();
            }).catch(function (err) {
              _this5.loadObj.close();
            });
          } else {
            done();
          }
        }
      });
    },
    refund: function refund(row) {
      var _this6 = this;
      this.$prompt('请输入退款金额', '退款', {
        confirmButtonText: '确定退款',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入退款金额',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this6.loadObj = _this6.$loading({
              lock: true,
              text: '正在退款',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;
            _this6.$post('wxapi/apply/launch_refund', {
              uid: row.id,
              withdraw_money: value < 0 ? Math.abs(value) : value,
              is_manage: 1
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_user_refund_1 用户退款
              _this6.$userReport.reportUserRefund(row.id, row.nick_name, value < 0 ? Math.abs(value) : value);
              _this6.loadObj.close();
              _this6.$message({
                message: '退款成功',
                type: 'success'
              });
              _this6.toQuery();
              done();
            }).catch(function (err) {
              _this6.loadObj.close();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 设置会员
     */
    setUserMember: function setUserMember() {
      var _this7 = this;
      var params = this.memberObj;
      this.loadObj = this.$loading({
        lock: true,
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/card/save_user_member_card_info', params).then(function (res) {
        // 【操作埋点】2026-05-25 pc_user_member_1 设置会员
        _this7.$userReport.reportUserMember(params.uid, params);
        _this7.loadObj.close();
        _this7.$message({
          message: '设置成功',
          type: 'success'
        });
        _this7.memberDialog = false;
      }).catch(function (err) {
        _this7.loadObj.close();
      });
    },
    /**
     * 显示交易记录弹窗
     * @param {Object} row
     */
    showTradeLog: function showTradeLog(row) {
      this.tradeLogQuery.user_id = row.id;
      this.tradeLogQuery.start = 1;
      this.tradeLogDialogVisible = true;
      this.getTradeLogList();
    },
    /**
     * 获取交易记录列表
     */
    getTradeLogList: function getTradeLogList() {
      var _this8 = this;
      this.tradeLogLoading = true;
      var params = {
        current_user_id: this.tradeLogQuery.user_id,
        start: this.tradeLogQuery.start - 1,
        limit: this.tradeLogQuery.limit
      };
      this.$get('wxapi/consume_log', params).then(function (res) {
        _this8.tradeLogLoading = false;
        _this8.tradeLogList = res.list || [];
        _this8.tradeLogQuery.page_num = res.page_num || 1;
      }).catch(function () {
        _this8.tradeLogLoading = false;
      });
    },
    /**
     * 显示订单详情
     * @param {Object} row
     */
    showOrderDetail: function showOrderDetail(row) {
      var _this9 = this;
      if (!row.order_id) {
        this.$message.warning('无关联订单');
        return;
      }
      this.orderDetailLoading = true;
      this.$get('wxapi/order_detail', {
        order_id: row.order_id
      }).then(function (res) {
        _this9.orderDetailLoading = false;
        _this9.orderDetail = res;
        _this9.orderDetail.agents_profit = res.order_info ? res.order_info.agents_profit : {};
        _this9.orderDetail.money_paid = res.order_info ? res.order_info.money_paid : '-';
        _this9.orderDetailDialog = true;
      }).catch(function () {
        _this9.orderDetailLoading = false;
      });
    }
  }
};